// ----------------------------------------------------------------------------
// Snippet: Mini Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import { formatMoney }        from '@shopify/theme-currency';
import { lineItemCardHtml }   from 'snippets/cart-js/ajax-add-cart';
import { cartSubtotalUpdate } from 'snippets/cart-js/ajax-add-cart';
import 'snippets/cart-js/cart-js';
import 'snippets/card/card';

// Styles
import './_mini-cart.scss';


Shopify.miniCart = (function($){

    var _config = {
        itemsContainerSelector : '.mini-cart__items-container',
        itemsListSelector      : '.mini-cart__items-list',
        miniCartFooterSelector : '.mini-cart__footer',
        shopifyAjaxCartURL     : '/cart.js',
    };

    var _init = function(){

        $(document).ready(function(){

            var $itemsContainer = $(_config.itemsContainerSelector);
            var $itemsList      = $(_config.itemsListSelector);

            if ( $itemsContainer.length ) {
                // Update cart count and cart modal.
                $.ajax({
                    url: _config.shopifyAjaxCartURL,
                    cache: false,
                    dataType: "json",
                    success: function(cart) {
                        
                        if (cart.items.length) {
                            $itemsList.empty();
                            $.each(cart.items, function(index, value){// loop through each line items in cart
                                var $lineItemCardHtml = lineItemCardHtml(value, 0, true);
                                if ( $itemsList.length ) {
                                    $itemsList.append('<li class="mini-cart__line-item">'+ $lineItemCardHtml +'</li>');
                                }
                            })
                            //Adds Pulse Animation to Cart Count
                            $('.cart__item-count-container').addClass('cart__item-count-container--active');
                        }else{
                            $itemsList.empty();
                            $itemsList.append('<li class="mini-cart__line-item">There are no items in the cart</li>');
                            $('.cart__item-count-container').removeClass('cart__item-count-container--active');
                        }
                        
                        // Update cart subtotal and items
                        cartSubtotalUpdate(cart);
                    }
                });
            }
        });
    }
    return {
        init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                $.extend(_config, params);
                // Action
                $(function() {
                    _init();
                });
        },
        getConfig: function() {
            return _config;
        }
    }
})($)


Shopify.miniCart.init();

$(document).ready(function(){

    $('.mini-cart__item--dropdown').on('hover', function(){

        if (!$(this).hasClass('js--isOpen')) {
            $(this).addClass('js--isOpen');
            $(this).find('[tabindex="-1"]').each(function(){
                $(this).attr('tabindex', 0);
            })
        }
    })

    $('.mini-cart__item--dropdown').on('focusout', function(){

        if ($(this).hasClass('js--isOpen')) {
            $(this).removeClass('js--isOpen');
        }
    })
})

$(document).on('keyup', function(e) {
    
    if (e.key == "Escape" && $('.mini-cart__item--dropdown').hasClass('js--isOpen')) {
        $('.mini-cart__item--dropdown').removeClass('js--isOpen');
    }
});
